import { filter, delay, skip, mergeMap, mapTo, scan, startWith, buffer } from 'rxjs/operators'
import { merge, fromEvent } from 'rxjs'
import { Epic } from 'interfaces/middleware'
import { INSIGHT_EVENT_CATEGORY, IMPERSONALIZED_INSIGHT_EVENT_CATEGORY } from 'components/features/beacon/types'
import { SEND_EVENT } from 'components/features/beacon/actions'
import { byType } from 'rxOperators/byType'
import { end } from 'rxOperators/end'
import { EVENTS_BUFFER_SIZE, sendEventsByCategory, sendPostImpressions } from 'components/features/beacon/helpers'


// flushEventsEpic sends events to the server, when tab visibility is changed or buffer's limit exceeded
export const flushEventsEpic: Epic = (action$, _store, { scheduler, document, sendBeacon }) => {
  const visibilityChange$ = fromEvent(document, 'visibilitychange')
  const pageHide$ = fromEvent(document, 'pagehide')
  const beforeUnload$ = fromEvent(document, 'beforeunload')
  const unload$ = fromEvent(document, 'unload')
  // More details https://www.igvita.com/2015/11/20/dont-lose-user-and-app-state-use-page-visibility/
  const tabVisibility$ = merge(
    visibilityChange$,
    pageHide$,
    beforeUnload$,
    unload$,
  )

  const sendEvent$ = action$
    .pipe(byType(SEND_EVENT))

  // Events are sent every time, when closingNotifier$ emits value
  const closingNotifier$ = merge(
    // Events counter
    merge(
      sendEvent$.pipe(mapTo(1)), // increment counter
      tabVisibility$.pipe(mapTo(0)) // reset counter, when tab's visibility was changed (and so events were sent)
    ).pipe(
      startWith(0), // initial counter's value
      scan((count, increment) => increment ? count + increment : 0),
      filter((count) => count % EVENTS_BUFFER_SIZE === 0), // send event, when buffer's limit exceeded
      skip(1), // skip initial counter's value
      delay(0, scheduler), // delay is required, because at first buffer should get an event, then later send it
    ),
    // Send events, when tab's visibility is changed
    tabVisibility$,
  )

  return sendEvent$.pipe(
    buffer(closingNotifier$), // save events to buffer
    filter((actions) => actions.length > 0),
    mergeMap((actions) => merge(
      sendEventsByCategory(actions, INSIGHT_EVENT_CATEGORY, sendBeacon),
      sendEventsByCategory(actions, IMPERSONALIZED_INSIGHT_EVENT_CATEGORY, sendBeacon),
      sendPostImpressions(actions, sendBeacon),
    )))
    .pipe(end(() => {}))
}
